import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	notFoundContainer: {
		display: 'block',
		margin: 110,
		textAlign: 'center',
	},
});
